export function normalizeOrders(originalData) {
  return originalData.reduce((accumulator, pendingOrder) => {
    const { lines, ...otherOrderProperties } = pendingOrder;
    const orders = lines.map((line) => {
      const { asin, ...otherLineProperties } = line;

      return {
        ...otherOrderProperties,
        ...otherLineProperties,
      };
    });

    return [...accumulator, ...orders];
  }, []);
}
